import axios, { AxiosInstance, AxiosError } from 'axios';
import { API_BASE } from '../Config';
import Cookies from 'js-cookie';
import { store } from '../states/store';
import { logout } from '../states/slices/authSlice';

const axiosInstance: AxiosInstance = axios.create({
  baseURL: API_BASE,
});

// Function to get the JWT token from the cookie
const getJwtTokenFromCookie = (): string => {
  // let str = document.cookie.replace(
  //     new RegExp(
  //       "(?:(?:^|.*;)\\s*" +
  //         encodeURIComponent('jwtToken').replace(/[-.+*]/g, "\\$&") +
  //         "\\s*\\=\\s*([^;]*).*$)|^.*$"
  //     ),
  //     "$1"
  //   );
  //   return str;
  return Cookies.get('jwtToken') || '';
};

// Add a request interceptor to attach the token to every outgoing request
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getJwtTokenFromCookie();
    if (token) {
      // Set the Authorization header with Bearer token format
      config.headers.Authorization = `Bearer ${token}`;
      console.log('Bearer token attached to request');
    } else {
      console.log('No token found in cookie');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor to handle authentication errors
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error: AxiosError) => {
    // Handle 401 Unauthorized errors
    if (error.response && error.response.status === 401) {
      // Clear authentication data and redirect to login
      store.dispatch(logout());
      // Redirect to login page if not already there
      if (window.location.pathname !== '/signing') {
        window.location.href = '/signing';
      }
    }
    return Promise.reject(error);
  }
);

// Helper functions for common API operations
export const apiGet = async (url: string) => {
  const response = await axiosInstance.get(url);
  return response.data;
};

export const apiPost = async (url: string, data?: any) => {
  const response = await axiosInstance.post(url, data);
  return response.data;
};

export const apiPut = async (url: string, data?: any) => {
  const response = await axiosInstance.put(url, data);
  return response.data;
};

export const apiDelete = async (url: string) => {
  const response = await axiosInstance.delete(url);
  return response.data;
};

export const apiPatch = async (url: string, data?: any) => {
  const response = await axiosInstance.patch(url, data);
  return response.data;
};

export default axiosInstance;